module.exports = __webpack_public_path__ + "static/art4-92b6db008941fa1b72ffe5766eb3b3e5.jpg";